import {useQuery, UseQueryOptions} from '@tanstack/react-query';

import {getUserCurrency} from '../api';
import {QUERY__USER_CURRENCY} from '../queryKeys';
import {UserCurrency} from '../types';

export const useGetUserCurrency = (
  username: string,
  options?: Omit<UseQueryOptions<UserCurrency>, 'queryKey' | 'queryFn'>,
) =>
  useQuery({
    queryKey: [QUERY__USER_CURRENCY, username],
    queryFn: () => getUserCurrency(username),
    ...options,
  });
